<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-toolbar flat>
                  <v-text-field v-model="journalToMigrate" append-icon="mdi-rocket" label="Journal Id To Migrate" single-line hide-details>
                  </v-text-field>

          <v-btn @click="processMigration()" :loading="responseProcessing" color="primary">Start Migration
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-alert dismissible close-text="Close Alert" border="left" :type="responseStatus" v-if="responseStatus">
          {{ migrationResponseMessage }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";

export default {
  data: () => ({
    responseStatus: null,
    migrationResponseMessage: null,
    responseProcessing: false,
    journalToMigrate: null
  }),
  computed: {
  },

  methods: {
    async processMigration() {

      if(this.journalToMigrate == null || this.journalToMigrate.length == 0) {
        this.responseStatus = "error";
        this.migrationResponseMessage = "Enter a journalId"
        return;
      }
      
      this.responseProcessing = true;
      this.responseStatus = null;
      this.migrationResponseMessage = null;

      const migrateJournalRequest = serverFunctions.getDataRequestObject(userFunctions.getLoggedInUser(), this.journalToMigrate);

      let migrationResponse = await serverFunctions.getRawPostResponse("/migrateJournal", migrateJournalRequest);

      this.responseProcessing = false;

      if (migrationResponse) {
        this.responseStatus = "success";
        this.migrationResponseMessage = "Migration Successful";
      } else {
        this.responseStatus = "error";
        this.migrationResponseMessage = "Migration Failed";
      }

    },
  },
};
</script>

<style scoped>
</style>
